import Template from './template';

function Modal(id) {

  function fadeIn() {
    const modal = document.querySelector('.modal');

    // modal--fade-enter
    // modal--fade-enter-active
    modal.setAttribute('aria-hidden', false);

    window.setTimeout(() => {
      modal.classList.add('modal--fade-enter-active');
    }, 100);
  }

  function fadeOut() {
    const modal = document.querySelector('.modal');

    modal.classList.add('modal--fade-exit');
    modal.classList.remove('modal--fade-enter');
    modal.classList.remove('modal--fade-enter-active');

    window.setTimeout(() => {
      modal.classList.add('modal--fade-exit-active');
    }, 100);
  }

  const onCloseModal = (event) => {
    event.preventDefault();

    fadeOut()

    window.setTimeout(() => {
      this.close();
    }, 300);
  }

  this.open = () => {
    Template('modal-termos-tpl', {
      id,
    });

    const buttonClose = document.querySelector('.modal__close');
    const overlay = document.querySelector('.modal__overlay');

    fadeIn();

    buttonClose.addEventListener('click', onCloseModal)
    overlay.addEventListener('click', onCloseModal)
  }

  this.close = () => {
    document.querySelector(`#${id}`).remove();
  }
}

export default Modal;
